<header class="header">
  <a href="https://www.beimbenz.de/"
    ><img src="assets/beimbenz-dark.png" alt="Beim BENZ" class="header-logo"
  /></a>
</header>
<main class="wrapper">
  <router-outlet></router-outlet>
  <cstmr-footer></cstmr-footer>
</main>
<p-toast
  [breakpoints]="{
    '920px': {
      width: '100%',
      right: '0',
      left: '0',
      bottom: '20px',
      top: 'auto',
    },
  }"
/>
